export default {
	data() {
		return {
			errorMessages: {
				serverError: "Sorry! We've encountered an unexpected system error -- the team has been notified and we will resolve it shortly!",
				//noSubscription: "You do not have a valid subscription, so some of the data requested cannot be accessed",
				networkError: "Unable to contact the server... you appear to be offline, please check your network connection",
				generalError: "There was a problem with your request"
			},
			requestsInFlight: {}
		}
	},
	methods: {
		generateRequestKey(url, payload) {
			return url + '|' + JSON.stringify(payload || {});
		},
		logError(url,payload,response,userMessage) {
			let apiKey = ""
			if (typeof localStorage.apiKey != 'undefined') 
				apiKey = localStorage.apiKey
			else  {
				if (window.location.pathname != "/login") {
					//window.location = "/login"
				}
			}

			let payloadJson = ""
			if (typeof data == 'string')
				payloadJson = payload
			else if (typeof data == 'object') {
				let payloadObj = {}
				for (var pair of payload.entries()) 
					payloadObj[pair[0]] = pair[1]

				payloadJson = JSON.stringify(payloadObj)
			}
			else
				payloadJson = JSON.stringify(payload)

			let responseJson = ""
			if (typeof response == 'string')
				responseJson = response
			else
				responseJson = JSON.stringify(response)

			let logPayload = new FormData()
			logPayload.append("tenant_id",this.$store.userDetails.tenant_id)
			logPayload.append("user_id",this.$store.userDetails.id)
			logPayload.append("endpoint",url)
			logPayload.append("payload_json",payloadJson)
			logPayload.append("response_json",responseJson)
			logPayload.append("user_agent",navigator.userAgent)

			if (userMessage)
				logPayload.append("user_error_message",userMessage)

			fetch(window.apiBase+"ErrorLog/save", {
				method: "POST",
				credentials: 'include',
				mode: "cors",
				headers: new Headers({
					'x-api-key': apiKey
				}),
				body: logPayload
			})
		},
		handleUnAuthorized(response) {
			if (typeof response != 'undefined' && "subExpired" in response && response.subExpired) {
				if (this.$store.userDetails.id == this.$store.company.managing_user_id)
					this.$router.push("/settings/tradetraks-subscription")
				else {
					this.alertErrors(["You do not have a valid subscription, so some of the data requested cannot be accessed"])

		 			//else 
					//	this.alertErrors(response.errors)
				}
			}
		},
		handleErrorCode(response,responseJSON,payload,url) {
			let vm = this

			let userMessage = ""

			if (response.status == 500 && !("errors" in responseObj)) 
				vm.alertFail(vm.errorMessages.serverError)
			else if (response.status == 403 || response.status == 401) {
				//vm.alertFail("Unauthorized (Error "+response.status+")") 
				//vm.alertFail()

				responseJSON.then(responseObj => {
					if ("errors" in responseObj)
						vm.alertErrors(responseObj.errors)
				})
				
				vm.$bus.$emit("loginStatus",false);
				vm.$bus.$emit("logout")
				vm.spinner(false)
			}
			else {

				responseJSON.then(responseObj => {
					if ("errors" in responseObj)
						vm.alertErrors(responseObj.errors)
					else
						vm.alertFail(vm.errorMessages.generalError + " (code " + response.status + ")",true)
				})
			}
		},
		/*
		encodePayload(payload) {
			let newPayload
			

			Object.keys(payload).forEach(key => {
				if (Array.isArray(payload[key])) {

				}
				else if (typeof payload[key] == 'object') {

				}
				else
					newPayload[key] = encodeURIComponent(payload[key])
			})
		},
		*/
		buildQueryString(payload) {
			let queryString = ""
			if (payload) {
				queryString = "?"
				//build out query string
				Object.keys(payload).forEach(key => {

					let value = payload[key]

					//check if value is valid JSON
					let finalValue = ""

					if (typeof value == "object" || typeof value == "array") 
						value = JSON.stringify(value)

					finalValue = encodeURIComponent(value)
					
					if (queryString == "?") {
						queryString += key+"="+finalValue
					}
					else {
						queryString += "&"+key+"="+finalValue
					}
				})
			}

			return queryString
		},
		compileHeaders(requestMethod,options) {
			let headers = {}

			if (!options || !("omitApiKey" in options) || !options.omitApiKey) {
				let apiKey = ""
				if (typeof localStorage.apiKey != 'undefined') 
					apiKey = localStorage.apiKey

				headers['X-Api-Key'] = apiKey
			}

			if ("userDetails" in this.$store && this.$store.userDetails && "masterKeySession" in this.$store.userDetails)
				headers['X-Master-Key-Session'] = this.$store.userDetails.masterKeySession ? "true" : "false"

			if (!requestMethod || requestMethod.toLowerCase() == 'get')
				headers['Content-Type'] = 'text/plain'

			return headers
		},
		compilePostPayload(data) {
			let localData = {}
			try {
				localData = JSON.parse(JSON.stringify(data))
			}
			catch (e) {}

			let payload = new FormData()
			for (var key in localData) {
				if (typeof localData[key] == "object")
					localData[key] = JSON.stringify(localData[key])

				payload.append(key, localData[key])
			}

			return payload
		},
		handleJsonParseError(caughtError,url,payload,response) {
			let vm = this

			response.text().then(responseBody => {
				if (url.indexOf("ErrorLog") == -1) //make sure we're not logging an error of an error
					vm.logError(url,payload,caughtError,responseBody)
			})

			vm.alertFail(vm.errorMessages.serverError)
		},
		handleCompletedRequest(alertOnFail, json) {
			let vm = this

			if (json && "time" in json)
				vm.$store.timeNow = json.time

			if (json && "token_expiry" in json)
				vm.$store.tokenExpiry = json.token_expiry

			//if (!options || !("noUnauthRedirect" in options) || options.noUnauthRedirect == false)
			//	vm.handleUnAuthorized(j)

			if (json && "subExpired" in json && json.subExpired) {
				vm.alertFail(vm.$store.company.company_name + " currently does not have a valid subscription to Tradetraks. Some features are not accessible without a paid plan")
			}
			else {
				if (alertOnFail && typeof json != 'undefined' && !json.success) {
					if ("errors" in json) {
						vm.alertErrors(json.errors)
						vm.$store.errorList = json.errors
					}
					else if ("message" in json)
						vm.alertFail(json.message)
					else
						vm.alertFail(vm.errorMessages.generalError)
				}
				else if (alertOnFail && "message" in json)
					vm.alertFail(json.message)
			}
		},
		getJSON: function(url, payload, alertOnFail,options) {
			let vm = this


			//exclude any /find endpoints
			/*
			if (url.indexOf("/find") == -1) {
				const requestKey = vm.generateRequestKey(url, payload);

				if (vm.requestsInFlight[requestKey]) {
					console.warn("Request suppressed (in-flight):", requestKey);
					return Promise.resolve({
						success: false,
						errors: ["Redundant request -- please wait for the first request to finish"]
					});
				}

				// --- Mark as in-flight
				vm.requestsInFlight[requestKey] = true;

				// --- Fail-safe: auto-clear after 30s
				setTimeout(() => {
					try {
						delete vm.requestsInFlight[requestKey];
					}
					catch (e) {}
				}, 30000);
			}
			*/

			let queryString = this.buildQueryString(payload)

			return new Promise(function(resolve, reject) {

				let compiledUrl = window.apiBase+url+queryString
				if (options && "fullUrl" in options && options.fullUrl) {
					compiledUrl = url+queryString
				}

				fetch(compiledUrl,{
					credentials: 'include',
					mode: 'cors',
					headers: vm.compileHeaders('get',options)
				})
				.then(function(response){

					let responseClone = response.clone() //clone the response object so we can resolve to text if necessary

					let responseJSON = response.json()
						.catch(e => {
							vm.handleJsonParseError(e,url,payload,responseClone)
						})

					if (!response.ok)  {
						vm.handleErrorCode(response,responseJSON,payload,url)
					}
					
					return responseJSON
				})
				.catch(e => {

					//network error
					if (alertOnFail)
						vm.alertFail(vm.errorMessages.networkError)

					if (typeof e != 'undefined')
						resolve(e)

				})
				.then(function(j){
					vm.handleCompletedRequest(alertOnFail, j)

					// Clear in-flight request
					/*
					try {
						delete vm.requestsInFlight[requestKey];
					}
					catch (e) {}
					*/

					resolve(j)
					
				})
				/*
				.catch(function(err) {
					// Also clear in-flight on network failure
					try {
						delete vm.requestsInFlight[requestKey];
					}
					catch (e) {}
					throw err;
				});
				*/
			});

		},
		postData: function(url, data, alertOnFail) {
			let vm = this

			this.$store.errorList = {}

			return new Promise(function (resolve, reject) {

				fetch(window.apiBase+url, {
					method: "POST",
					credentials: 'include',
					mode: "cors",
					headers: vm.compileHeaders('post'),
					body: vm.compilePostPayload(data)
				})
				.then(function(response){

					let responseClone = response.clone() //clone the response object so we can resolve to text if necessary

					let responseJSON = response.json()
						.catch(e => {
							vm.handleJsonParseError(e,url,data,responseClone)
						})

					if (!response.ok) 
						vm.handleErrorCode(response,responseJSON,payload,url)	
					
					return responseJSON
				})
				.catch(e => {
					if (alertOnFail)
						vm.alertFail(vm.errorMessages.networkError)

					if (typeof e != 'undefined')
						resolve(e)
				})
				.then(function(j){
					vm.handleCompletedRequest(alertOnFail, j)

					resolve(j)
				})
			})
		},
		/**
		*	a further abstracted function to save a model.
		*	handles the notifications, errors, and on success invokes the onSuccessCallback
		**/
		saveRecord(resource, payload, onSuccessCallback) {
			let vm = this

			if ("statusWorking" in vm)
				vm.statusWorking = true;

			this.$store.errorList = {}

			vm.postData(resource+"/save",payload,true).then(function(response) {
				if ("statusWorking" in vm)
					vm.statusWorking = false

				if (response.success == true){

					if (onSuccessCallback) {

						if (typeof onSuccessCallback == "string")
							vm[onSuccessCallback](response)
						else if (typeof onSuccessCallback == "function")
							onSuccessCallback(response)
					}
					else 
						vm.alertSaved("Saved!",true)
				}
			})
		},
		deleteRecord(resource,id,onSuccessCallback) {
			let vm = this

			vm.spinner(true)

			vm.postData(resource+"/delete",{id: id}).then(function(response){
				vm.spinner(false)

				if (response.success) {
					if (onSuccessCallback) {

						if (typeof onSuccessCallback == "string")
							vm[onSuccessCallback](response)
						else if (typeof onSuccessCallback == "function")
							onSuccessCallback(response)
					}
					else 
						vm.alertSuccess("Deleted!",true)
				}
				else {
					if ("errors" in response)
						vm.alertErrors(response.errors)
					else if ("message" in response)
						vm.alertFail(response.message)
				}
			})
		}
		
	}
}